import Dialog from "./DialogComponent.vue";
import Vue from "vue";

/* eslint-disable no-param-reassign */
const setup = (options, instance) => {
  const {
    message,
    title,
    confirmButtonText,
    cancelButtonText,
    closeOnClickOverlay
  } = options;

  return new Promise((resolve, reject) => {
    instance.show = true;
    instance.title = title;
    instance.message = message;
    instance.confirmButtonText = confirmButtonText || "确认";
    instance.cancelButtonText = cancelButtonText || "取消";
    instance.closeOnClickOverlay = closeOnClickOverlay || false;
    instance.close = () => {
      reject();
    };
    instance.confirm = () => {
      resolve();
    };
  });
};
const PhDialog = {
  install: Vue => {
    const DialogConstructor = Vue.extend(Dialog);
    const instance = new DialogConstructor();
    instance.$mount(document.createElement("div"));
    document.body.appendChild(instance.$el);

    Vue.prototype.$phdialog = {
      confirm: options => {
        return setup(options, instance);
      }
    };
  },
  confirm: options => {
    const DialogConstructor = Vue.extend(Dialog);
    const instance = new DialogConstructor();
    instance.$mount(document.createElement("div"));
    document.body.appendChild(instance.$el);

    return setup(options, instance);
  }
};

export default PhDialog;
